// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"K--z"};